var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBlockUser = function SvgBlockUser(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 13,
    "data-width-20": 17,
    "data-width-24": 20,
    viewBox: "0 0 20.8 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.7 12a4 4 0 1 1 0 8 4 4 0 0 1 0-8m-1.509 6.355a2.8 2.8 0 0 0 3.864-3.864zm1.51-5.155a2.8 2.8 0 0 0-2.357 4.308l3.864-3.864A2.8 2.8 0 0 0 16.7 13.2M8.45 9.5a4.75 4.75 0 1 1 0-9.5 4.75 4.75 0 0 1 0 9.5m0-8a3.25 3.25 0 1 0 3.25 3.25A3.26 3.26 0 0 0 8.45 1.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M12.2 13s-1.71-1-3.5-1c-6.4 0-8 4.667-8 7h11"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBlockUser);
export default ForwardRef;